const apiBaseURL = process.env.REACT_APP_API_BASE_URL
const socketURL = process.env.REACT_APP_SOCKET_URL
const baseURL = process.env.REACT_APP_BASE_URL

export { apiBaseURL, baseURL, socketURL }
